






















import AbpBase from "@/lib/abpbase";
import { Component } from "vue-property-decorator";
import { QueryAuditLog } from "@/api/audit/auditLog";

@Component({})
export default class AuditLog extends AbpBase {
    list: any[] = [];
    tableTotalSize: number = 0;
    loading: boolean = false;
    queryCondition: any = {
        page: 1,
        pageSize: 10,
        type: "0",
        start: null,
        end: null,
    };
    columns = [
        {
            key: "id",
            title: "日志编号",
            width: 100,
        },
        {
            key: "executionTime",
            title: "操作时间",
            width: 200,
            render: (h: any, p: any) => {
                return h("span", {}, this.formatDateTime(p.row.executionTime));
            },
        },
        {
            key: "userName",
            title: "操作人",
            width: 120,
            render: (h: any, p: any) => {
                if (p.row.methodName == "Authenticate") {
                    //登录操作显示登录人
                    if (p.row.parameters) {
                        let regex = /"userNameOrEmailAddress":"(.*)","password"/;
                        let res = regex.exec(p.row.parameters);
                        if (res && res.length >= 2) {
                            return h("span", {}, res[1]);
                        }
                    }
                } else {
                    return h("span", {}, p.row.userName);
                }
            },
        },
        {
            key: "methodName",
            title: "操作",
            width: 250,
            render: (h: any, p: any) => {
                let opt = "";
                switch (p.row.serviceName) {
                    case "Zen.Controllers.TokenAuthController":
                        opt = "登陆认证";
                        break;
                    case "Zen.Users.UserAppService":
                        if (p.row.methodName === "Update") {
                            opt = "修改用户信息";
                        } else if (p.row.methodName === "Create") {
                            opt = "新增用户";
                        } else if (p.row.methodName === "Delete") {
                            opt = "删除用户";
                        } else {
                            opt = "读取用户信息";
                        }
                        break;
                    case "Zen.Roles.RoleAppService":
                        if (p.row.methodName === "Update") {
                            opt = "修改角色与权限";
                        } else if (p.row.methodName === "Create") {
                            opt = "新增角色";
                        } else if (p.row.methodName === "Delete") {
                            opt = "删除角色";
                        } else {
                            opt = "读取角色信息";
                        }
                        break;
                    default:
                        opt = p.row.serviceName + "." + p.row.methodName;
                        break;
                }
                return h("span", {}, opt);
            },
        },
        {
            key: "clientIpAddress",
            title: "客户端IP",
            width: 160,
            render: (h: any, p: any) => {
                let ip = p.row.clientIpAddress;
                if (ip == "::1") {
                    ip = "127.0.0.1";
                }
                return h("span", {}, ip);
            },
        },
        {
            key: "browserInfo",
            title: "浏览器信息",
            minWidth: 150,
            tooltip: true,
        },
        {
            key: "parameters",
            title: "请求参数",
            minWidth: 200,
            tooltip: true,
        },
        {
            key: "exception",
            title: "操作状态",
            width: 120,
            render: (h: any, p: any) => {
                let props: any = {};
                if (p.row.exception) {
                    props.style = { color: "red" };
                }
                return h(
                    "span",
                    props,
                    p.row.exception == null ? "操作成功" : "操作失败"
                );
            },
        },
    ];

    /**
     * 换页操作
     */
    pageChange(val: any) {
        this.queryCondition.page = val;
        this.getData();
    }

    /**
     * 获取数据
     */
    async getData() {
        this.loading = true;
        let res = await QueryAuditLog(this.queryCondition);
        this.loading = false;
        this.list = res.data.items;
        this.tableTotalSize = res.data.totalCount;
        this.loading = false;
    }

    created() {
        this.getData();
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/audit/auditLog.vue